module.exports = __webpack_public_path__ + "img/sg.45fb3666.svg";